"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButton = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// const textColor = {
//   white: "white",
//   black: "#333;",
//   blue: "#2196F3",
// };
// const backgroundColor = {
//   primary: "#3699FF",
//   secondary: "black",
//   light: "#E3F2FD",
// };
var buttonSize = {
  small: "8px 14px",
  medium: "11px 20px",
  large: "12px 24px"
};

var StyledButton = _styled.default.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: 0;\n  border-radius: 4px;\n  cursor: pointer;\n  display: inline-block;\n  line-height: 1;\n  min-width: 100px;\n  outline: none;\n  font-size: 14px;\n  font-weight: ", ";\n  text-transform: ", ";\n  box-shadow: ", ";\n  color: ", ";\n  background-color: ", ";\n  border: ", ";\n  padding: ", ";\n"])), function (_ref) {
  var fontWeight = _ref.fontWeight;
  return fontWeight;
}, function (_ref2) {
  var textTransform = _ref2.textTransform;
  return textTransform;
}, function (_ref3) {
  var boxShadow = _ref3.boxShadow;
  return boxShadow && "0px 0px 2px rgba(0, 0, 0, 0.12), 0px 2px 2px rgba(0, 0, 0, 0.24)";
}, function (_ref4) {
  var text = _ref4.text,
      disabled = _ref4.disabled,
      variant = _ref4.variant,
      background = _ref4.background,
      borderColor = _ref4.borderColor;
  return variant === "outlined" ? disabled ? "#E0E0E0" : text ? text : borderColor ? borderColor : background : variant === "contained" ? disabled ? "#A6A6A6" : text ? text : background : "none";
}, function (_ref5) {
  var background = _ref5.background,
      disabled = _ref5.disabled,
      variant = _ref5.variant;
  return variant === "contained" ? disabled ? "#E0E0E0" : background : "transparent";
}, function (_ref6) {
  var background = _ref6.background,
      variant = _ref6.variant,
      disabled = _ref6.disabled,
      borderColor = _ref6.borderColor;
  return variant === "outlined" && "1px solid " + (disabled ? "#E0E0E0" : borderColor !== null && borderColor !== void 0 ? borderColor : background);
}, function (_ref7) {
  var size = _ref7.size;
  return buttonSize[size];
});

exports.StyledButton = StyledButton;

//# sourceMappingURL=Button.style.js.map